"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RenderField = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends4 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _i18n = _interopRequireWildcard(require("@i18n"));
var _reactRedux = require("react-redux");
var _Input = _interopRequireDefault(require("../../Input"));
var _core = require("@material-ui/core");
var _Autocomplete = _interopRequireDefault(require("@material-ui/lab/Autocomplete"));
var _dokia = _interopRequireDefault(require("../../../@api/dokia"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var RenderField = function RenderField(_ref) {
  var field = _ref.field,
    onChange = _ref.onChange,
    _ref$validateRequired = _ref.validateRequired,
    validateRequired = _ref$validateRequired === void 0 ? true : _ref$validateRequired;
  var _useState = (0, _react.useState)({}),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  if (!field.value) {
    field.value = '';
  }
  var update = function update(e) {
    field.value = e.target.value;
    onChange(field);
    setState({});
  };
  //(field.type)
  switch (field.type) {
    case 'entity.form.field.types.singleLine':
      return singleLineField(field, update, validateRequired);
    case 'entity.form.field.types.multipleLine':
      return multipleLineField(field, update, validateRequired);
    case 'entity.form.field.types.number':
      return numberField(field, update, validateRequired);
    case 'entity.form.field.types.currency':
      return currencyField(field, update, validateRequired);
    case 'entity.form.field.types.date':
      return dateField(field, update, validateRequired);
    case 'entity.form.field.types.datetime':
      return datetimeField(field, update, validateRequired);
    case 'entity.form.field.types.checkbox':
      return checkboxField(field, update, validateRequired);
    case 'entity.form.field.types.singleSelection':
      return singleSelectionField(field, update, validateRequired);
    case 'entity.form.field.types.multiSelection':
      return multiSelectionField(field, update, validateRequired);
  }
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
};
exports.RenderField = RenderField;
var singleLineField = function singleLineField(field, update, validateRequired) {
  return /*#__PURE__*/_react["default"].createElement(_Input["default"], {
    mode: "outlined top-label",
    label: field.title,
    value: field.value,
    onChange: update,
    required: validateRequired && field.required,
    message: validateRequired && field.required && !field.value ? (0, _i18n["default"])('field.required') : ''
  });
};
var multipleLineField = function multipleLineField(field, update, validateRequired) {
  return /*#__PURE__*/_react["default"].createElement(_Input["default"], {
    mode: "outlined top-label",
    label: field.title,
    value: field.value,
    onChange: update,
    required: validateRequired && field.required,
    message: validateRequired && field.required && !field.value ? (0, _i18n["default"])('field.required') : '',
    multiple: true
  });
};
var numberField = function numberField(field, update, validateRequired) {
  return /*#__PURE__*/_react["default"].createElement(_Input["default"], {
    mode: "outlined top-label",
    type: "formatted-number",
    prefix: "",
    label: field.title,
    value: field.value,
    onChange: update,
    required: validateRequired && field.required,
    message: validateRequired && field.required && !field.value ? (0, _i18n["default"])('field.required') : '',
    multiple: true
  });
};
var currencyField = function currencyField(field, update, validateRequired) {
  return /*#__PURE__*/_react["default"].createElement(_Input["default"], {
    mode: "outlined top-label",
    type: "formatted-number",
    prefix: _i18n.current["default"].currency.symbol,
    label: field.title,
    value: field.value,
    onChange: update,
    required: validateRequired && field.required,
    message: validateRequired && field.required && !field.value ? (0, _i18n["default"])('field.required') : '',
    multiple: true
  });
};
var dateField = function dateField(field, update, validateRequired) {
  return /*#__PURE__*/_react["default"].createElement(_Input["default"], {
    mode: "outlined top-label",
    type: "date",
    label: field.title,
    value: field.value,
    onChange: update,
    required: validateRequired && field.required,
    message: validateRequired && field.required && !field.value ? (0, _i18n["default"])('field.required') : '',
    multiple: true
  });
};
var datetimeField = function datetimeField(field, update, validateRequired) {
  return /*#__PURE__*/_react["default"].createElement(_Input["default"], {
    mode: "outlined top-label",
    type: "datetime-local",
    label: field.title,
    value: field.value,
    onChange: update,
    required: validateRequired && field.required,
    message: validateRequired && field.required && !field.value ? (0, _i18n["default"])('field.required') : '',
    multiple: true
  });
};
var checkboxField = function checkboxField(field, update, validateRequired) {
  if (!field.value) field.value = false;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_core.FormControlLabel, {
    control: /*#__PURE__*/_react["default"].createElement(_core.Checkbox, {
      checked: field.value,
      onChange: function onChange(e) {
        update({
          target: {
            value: e.target.checked
          }
        });
      }
    }),
    label: field.title
  }));
};
var singleSelectionField = function singleSelectionField(field, update, validateRequired) {
  return /*#__PURE__*/_react["default"].createElement(_Autocomplete["default"], {
    id: "tags-standard",
    options: field.options,
    getOptionLabel: function getOptionLabel(option) {
      return option.name || '';
    },
    defaultValue: field.defaultValue,
    renderInput: function renderInput(params) {
      var _extends2;
      return /*#__PURE__*/_react["default"].createElement(_core.TextField, (0, _extends4["default"])({}, params, (_extends2 = {
        variant: "standard",
        label: field.title,
        placeholder: field.title
      }, (0, _defineProperty2["default"])(_extends2, "variant", "outlined"), (0, _defineProperty2["default"])(_extends2, "className", "autocomplete"), _extends2)));
    },
    onChange: function onChange(e, newValue) {
      update({
        target: {
          value: newValue
        }
      });
    }
  });
};
var multiSelectionField = function multiSelectionField(field, update, validateRequired) {
  return /*#__PURE__*/_react["default"].createElement(_Autocomplete["default"], {
    multiple: true,
    id: "tags-standard",
    options: field.options,
    getOptionLabel: function getOptionLabel(option) {
      return option.name || '';
    },
    defaultValue: field.defaultValue ? [{
      name: field.defaultValue
    }] : [],
    renderInput: function renderInput(params) {
      var _extends3;
      return /*#__PURE__*/_react["default"].createElement(_core.TextField, (0, _extends4["default"])({}, params, (_extends3 = {
        variant: "standard",
        label: field.title,
        placeholder: field.title
      }, (0, _defineProperty2["default"])(_extends3, "variant", "outlined"), (0, _defineProperty2["default"])(_extends3, "className", "autocomplete"), _extends3)));
    },
    onChange: function onChange(e, newValue) {
      update({
        target: {
          value: newValue
        }
      });
    }
  });
};
var EntityFieldsForm = function EntityFieldsForm(_ref2) {
  var entity = _ref2.entity,
    document = _ref2.document,
    _ref2$validateRequire = _ref2.validateRequired,
    validateRequired = _ref2$validateRequire === void 0 ? true : _ref2$validateRequire,
    onChange = _ref2.onChange;
  var onFieldChange = function onFieldChange(field) {
    _dokia["default"].document.validate(document);
    onChange();
  };
  (0, _react.useEffect)(function () {
    _dokia["default"].document.validate(document);
  }, []);
  var allFields = (0, _react.useMemo)(function () {
    return Object.values(entity.fields).sort(function (a, b) {
      if (a.order > b.order) return 1;
      if (a.order < b.order) return -1;
      return 0;
    });
  }, [entity.fields]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "entity-form-fields-content"
  }, /*#__PURE__*/_react["default"].createElement("h3", null, entity.name), /*#__PURE__*/_react["default"].createElement("div", {
    className: "fields"
  }, allFields.map(function (field, i) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: i,
      order: field.order,
      className: "field-content"
    }, /*#__PURE__*/_react["default"].createElement(RenderField, {
      field: field,
      onChange: onFieldChange,
      validateRequired: validateRequired
    }));
  })));
};
var _default = EntityFieldsForm;
exports["default"] = _default;